import { render } from "./BSidebar.vue?vue&type=template&id=190079c1"
import script from "./BSidebar.vue?vue&type=script&lang=js"
export * from "./BSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__